<template>
<!-- Site wrapper -->
<div>
  <!-- Main content -->
  <section class="content">
    <!-- Default box -->
    <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <div v-if="flagsDeControle.carregandoDados.status" class="d-flex align-items-center">
              <span class="avisoDanger">{{flagsDeControle.carregandoDados.mensagem}}</span>
              <b-spinner class="ml-2" variant="danger"></b-spinner>
            </div>
            <form class="forms-sample">
              <!-- <div v-if="possuiNegociador" class="form-row"> // #396 -->
              <div class="form-row">
                <div class="form-group col-sm-12 col-md-6 col-lg-10 col-xl-10">
                  <label for="inputAreas">Áreas</label>
                  <v-select
                    class="style-chooser"
                    v-model="negociadorSelecionado"
                    @search="eventoDigitarBuscaPorNegociadores"
                    :options="comboNegociadoresDisponiveis"
                    :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status"
                    :filterable="false">
                    <template v-slot:no-options>
                      <em>Nenhum registro encontrado.</em>
                    </template>
                  </v-select>
                  <div class="avisoDanger text-left mt-1">{{dadosRetorno.listaDeErros['agreement_users_areas']}}</div>
                </div>
                <div class="form-group text-right col-sm-12 col-md-6 col-lg-2 col-xl-2">
                  <b-button class="botoes" style="margin-top: 2.0rem;" variant="outline-primary btn-sm" @click="adicionarNaLista()" :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status">Adicionar</b-button>
                </div>
                <default-table
                  :items="listaNegociadoresDoUsuario"
                  :fields="fields"
                  :busy="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status"
                  :tbody-tr-class="tabelaSemRegistros">
                  <template #empty>
                    <em>Nenhum registro encontrado.</em>
                  </template>
                  <template #cell(opcoes)="row">
                    <b-button class="botoes" variant="outline-danger btn-sm" title="Excluir" @click="excluirDaLista(row.item)" :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status">
                      <i class="fas fa-trash-alt"></i>
                    </b-button>
                  </template>
                </default-table>
              </div>
              <!-- <div v-if="!possuiNegociador" class="form-row col-sm-12 text-center">
                <div class="form-group col-sm-12 text-center">
                  <p class="card-text textos">Este usuário não possuí configurações de negociador, pois ele não tem permissão para "Acordos".</p>
                </div> // #396
              </div> -->
              <div v-if="flagsDeControle.manipulandoDados.status" class="d-flex align-items-center">
                <span class="avisoDanger">{{flagsDeControle.manipulandoDados.mensagem}}</span>
                <b-spinner class="ml-2" variant="danger"></b-spinner>
              </div>
            </form>
          </div>
        </div> <!-- card ends -->
      </div>
    </div>
  </section> <!-- /.content -->
</div><!-- ./wrapper -->
</template>

<script>
import Negociadores from './js/negociadores'
export default Negociadores
</script>

<style scoped>
@import "./scss/usuarios.scss";
</style>
